module.exports = __webpack_public_path__ + "media/videos/home/booking_animation-76890fca46088268df72ebf732e369b9.mp4";